// Esperar a que el DOM esté completamente cargado
window.addEventListener('DOMContentLoaded', function() {
  // Definir la función para inicializar el toggle de productos
  function inicializarToggleProductos() {

    // Seleccionar el botón
    const toggleButton = document.querySelector('.toggle-products-ver-mas');
    
    // Si no se encuentra el botón, intentar de nuevo en 100ms
    if (!toggleButton) {
      setTimeout(inicializarToggleProductos, 100);
      return;
    }
    
    // Seleccionar los productos ocultos
    const hiddenProducts = document.querySelectorAll('.grid__item.hidden');
    
    let isExpanded = false;
    
    // Agregar evento de clic al botón
    toggleButton.addEventListener('click', function(e) {
      isExpanded = !isExpanded;

      // Ahora sí podemos obtener los valores de forma segura
      const ver_mas = toggleButton.dataset.seemore;
      const ver_menos = toggleButton.dataset.seeless;

      // Mostrar u ocultar productos
      hiddenProducts.forEach(product => {
        if (isExpanded) {
          product.classList.remove('hidden');
        } else {
          product.classList.add('hidden');
        }
      });
      
      // Actualizar el texto del botón
      toggleButton.innerHTML = isExpanded 
      ? `<span class="text-toggle">${ver_menos}</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
          <path d="M5.5 10.4746H14.5" stroke="#fff"/>
        </svg>` 
      : `<span class="text-toggle">${ver_mas}</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
          <mask id="path-1-outside-1_6091_4407" maskUnits="userSpaceOnUse" x="5" y="4.5" width="11" height="11" fill="black">
            <rect fill="white" x="5" y="4.5" width="11" height="11"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11 9.5V5.5H10L10 9.5H6V10.5H10L10 14.5H11V10.5H15V9.5H11Z"/>
          </mask>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11 9.5V5.5H10L10 9.5H6V10.5H10L10 14.5H11V10.5H15V9.5H11Z" fill="white"/>
          <path d="M11 5.5H11.5V5H11V5.5ZM11 9.5H10.5V10H11V9.5ZM10 5.5V5H9.5V5.5L10 5.5ZM10 9.5V10H10.5L10.5 9.5H10ZM6 9.5V9H5.5V9.5H6ZM6 10.5H5.5V11H6V10.5ZM10 10.5H10.5V10H10V10.5ZM10 14.5H9.5V15H10V14.5ZM11 14.5V15H11.5V14.5H11ZM11 10.5V10H10.5V10.5H11ZM15 10.5V11H15.5V10.5H15ZM15 9.5H15.5V9H15V9.5ZM10.5 5.5V9.5H11.5V5.5H10.5ZM10 6H11V5H10V6ZM10.5 9.5V5.5L9.5 5.5L9.5 9.5H10.5ZM6 10H10V9H6V10ZM6.5 10.5V9.5H5.5V10.5H6.5ZM10 10H6V11H10V10ZM10.5 14.5L10.5 10.5H9.5L9.5 14.5H10.5ZM11 14H10V15H11V14ZM10.5 10.5V14.5H11.5V10.5H10.5ZM15 10H11V11H15V10ZM14.5 9.5V10.5H15.5V9.5H14.5ZM11 10H15V9H11V10Z" fill="white" mask="url(#path-1-outside-1_6091_4407)"/>
        </svg>`;
    });
  }
  
  // Llamar a la función para inicializar el toggle de productos
  inicializarToggleProductos();
});